import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";

export default class HeaderFull {

	static init() {
		this.header = document.querySelector(".header-main-full");
		if (this.header) {
			Header.init();
			this.initSubnav();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	static initSubnav(){

		this.menuLevelOne = this.header.querySelectorAll('.menu-item--lev1.menu-item-has-children');
		this.hoverTimeout = 150;

		if( window.innerWidth < 992 ) {

			this.menuLevelOne.forEach((item) => {
				let subNav = item.querySelector('.lev2');
				subNav.style.height = "auto";
				subNav.dataset.height = subNav.offsetHeight;
				subNav.style.height = 0;
				item.classList.remove("subnav-open");
				item.querySelector(":scope > a").addEventListener("click", Header.openSubNavBurger );
			});

		}else{

			this.menuLevelOne.forEach((item) => {

				let subNav = item.querySelector('.lev2');
				subNav.style.height = "50svh";
				item.classList.remove("subnav-open");

				item.addEventListener("mouseenter", () => {
					if (this.timeoutActive) {
						clearTimeout(this.leaveTimeout);
						clearTimeout(this.enterTimeout);
						this.enterTimeout = setTimeout(() => {
							this.menuLevelOne.forEach((item) => {
								let subNav = item.querySelector('.lev2');
								subNav.classList.remove('active');
							});
							GlobalVariables.smoother.paused(true);
							document.body.classList.add('header-menu-subnav-open');
							subNav.classList.add('active');
						}, this.hoverTimeout);
					} else {
						GlobalVariables.smoother.paused(true);
						document.body.classList.add('header-menu-subnav-open');
						subNav.classList.add('active');
					}
				});
				item.addEventListener("mouseleave", () => {
					this.timeoutActive = true;
					this.leaveTimeout = setTimeout( () => {
						GlobalVariables.smoother.paused(false);
						document.body.classList.remove('header-menu-subnav-open');
						subNav.classList.remove('active');
						this.timeoutActive = false;
					}, this.hoverTimeout );
				});
				item.removeEventListener("click", Header.openSubNavBurger);

			});

			Header.header.addEventListener('mouseenter', () => {
				if( Header.header.classList.contains('is-on-top') ) {
					setTimeout( () => {
						Header.removeClassByPrefix(Header.header, 'section');
						Header.header.classList.add('section');
						Header.header.classList.add(Header.header.dataset.sectionColor);
					}, this.hoverTimeout);
				}
			});

			Header.header.addEventListener('mouseleave', () => {
				if( Header.header.classList.contains('is-on-top') ) {
					setTimeout( () => {
						Header.header.className = Header.headerClass;
					}, this.hoverTimeout);
				}
			});

		}

	}

	static resize(){

		this.initSubnav();
		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused( false );
		}

	}
}
